<template>
  <div class="warehousingRecordPage">
    <!-- <div class="banner">
      <img src="../../assets/images/banner1.png" alt="" />
    </div> -->
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">入库管理</div>
    </div>

    <div class="input_box" @click="isShow = true">
      <van-field v-model="date" placeholder="选择日期" readonly />
      <!-- <input type="text" placeholder="选择日期" v-model="date" disabled /> -->
    </div>
    <div class="primary-button query" @click="searchData">按日期查找</div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div class="item" v-for="item in dataList" :key="item.id">
          <div class="tit">
            入库数量：<span>{{ item.num }}</span>
          </div>
          <div class="goods_desciption">
            <p class="txt1 fontSize-blueColor-sm">商品ID：{{ item.cm.id }}</p>
            <p class="txt2 fontSize-blueColor-sm">商品名称：</p>
            <p class="txt3">{{ item.cm.commodityname }}</p>
            <!-- <p class="txt3">{{ item.cm.commodityname_e }}</p>
            <p class="txt3">{{ item.cm.commodityname_y }}</p>
            <p class="txt3">{{ item.cm.commodityname_m }}</p>
            <p class="txt3">{{ item.cm.commodityname_t }}</p> -->
            <p class="txt1 fontSize-blueColor-sm">
              SKU采购编码：{{ item.cm.sku }}
            </p>
            <p class="fontSize-blueColor-sm">ISBN编码： {{ item.cm.ISBN }}</p>
          </div>
          <div class="operation operation_date">
            操作日期：<span>{{ item.createdate | formatDate }}</span>
          </div>
          <div class="operation">
            操作人员：<span>{{ item.userman }}</span>
          </div>
          <div class="search_icon" @click="handleDetail(item)">
            <i class="iconfont icon-details"></i>
          </div>
        </div>
      </div>
      <van-empty v-else description="暂无数据" />
    </div>
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>

    <van-popup v-model="isShow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { queryShopWareRecord } from "../../api/api";
import storage from "../../utils/storage";

export default {
  name: "wRecordList",
  data() {
    return {
      dataList: [],

      searchText: "",
      isShow: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      date: "",
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      }else {
        return date
      }
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let { keyword } = this.$route.params;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let params = {
        keyword,
        datestr: this.date,
        qyguid: this.$store.state.USERINFO.qy.qyguid,
      };
      queryShopWareRecord(params).then((res) => {
        this.dataList = res;
        Toast.clear();
      });
    },

    // 返回上一页
    handleReturn() {
      history.back();
    },

    // 详情
    handleDetail(item) {
      storage.set("DETAILITEM", item);
      this.$router.push("/recordIndex/wRecordDetail");
    },

    // 搜索
    searchData() {
      this.initData();
    },
    onConfirm(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let day = e.getDate();
      this.date =
        year +
        "-" +
        (month >= 10 ? month : "0" + month) +
        "-" +
        (day >= 10 ? day : "0" + day);
      this.isShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.warehousingRecordPage {
  .query.primary-button {
    margin: 80px auto 66px;
  }
  .main_content {
    font-size: 30px;
    color: #444;
    padding: 0 50px 280px;
    .title {
      margin-bottom: 65px;
      text-align: center;
    }
    .item {
      border: 2px solid #dedede;
      padding: 39px 36px 65px;
      position: relative;
      border-radius: 30px;
      margin-bottom: 60px;
      .tit {
        font-size: 32px;
        text-align: left;
        margin-bottom: 40px;
        span {
          font-size: 28px;
          color: #f40728;
        }
      }
      .operation_date {
        margin: 50px 0 30px;
      }
      .operation {
        font-size: 26px;
        span {
          font-size: 26px;
          color: #f40728;
        }
      }
      .search_icon {
        // display: inline-block;
        // content: "";
        // background: url(../../assets/images/search-icon.png) no-repeat center;
        // background-size: cover;
        position: absolute;
        right: 29px;
        bottom: 34px;
        // width: 51px;
        // height: 52px;
        .icon-details {
          font-size: 50px;
          color: #515151;
        }
      }
    }
  }
}
</style>